import React  from 'react';
import PropTypes from 'prop-types';
import range from 'lodash/range';

import themeable from 'zignal-landscape/lib/themeable';
import Checkbox from 'zignal-landscape/lib/Checkbox';
import Label from 'zignal-landscape/lib/Label';
import Slider from 'zignal-landscape/lib/Slider';
import GearsIcon from 'zignal-landscape/lib/Icon/GearsIcon';

class AutomationScoreSlider extends React.Component {
  constructor(props) {
    super(props);

    this.setMinAndMaxValuesIfValuesChange = this.setMinAndMaxValuesIfValuesChange.bind(this);
  }

  setMinAndMaxValuesIfValuesChange({values}) {
    const [min, max] = values;
    // Only change when new values are different to prevent useless store updates.
    if (min !== this.props.min || max !== this.props.max) {
      this.props.setMinAndMaxValues(values);
    }
  }

  render() {
    const {
      styles,
      toggleUnknownIncluded,
      min,
      max,
      isUnknownIncluded
    } = this.props;

    return (
      <div>
        <Label>
          Automation Score
          <span className={styles.iconWrapper}><GearsIcon /></span>
        </Label>
        <p className={styles.small}>
          Low: <span className={styles.bold}>{min}</span> to High: <span className={styles.bold}>{max}</span>
        </p>
        <div>
          <div className={styles.sliderWrapper}>
            <Slider
              min={0}
              max={100}
              onChange={this.setMinAndMaxValuesIfValuesChange}
              values={[min, max]}
              pitPoints={range(5, 100, 5)}
            />
          </div>
          <p className={styles.flexAndSpaceBetween}>
            <span>Low</span>
            <span>Med</span>
            <span>High</span>
          </p>
        </div>
        <div>
          <Checkbox
            id="isUnknownIncluded"
            onChange={toggleUnknownIncluded}
            checked={isUnknownIncluded}
          />
          <Label
            htmlFor="isUnknownIncluded"
            inline
            onChange={toggleUnknownIncluded}
          >
            <span className={styles.small}>Include Unknown</span>
          </Label>
        </div>
      </div>
    );
  }
}

AutomationScoreSlider.propTypes = {
  styles: PropTypes.object.isRequired,
  toggleUnknownIncluded: PropTypes.func.isRequired,
  setMinAndMaxValues: PropTypes.func.isRequired,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  isUnknownIncluded: PropTypes.bool.isRequired
};

export default themeable(AutomationScoreSlider);
